import { gql } from '@apollo/client';

export const GET_TRANSPORTATION_SET_OPTION_SPEECH = gql`
  query getTransportationSetOptionSpeech($transportationSetOptionId: String!) {
    transportationSetOptionSpeech(
      transportationSetOptionId: $transportationSetOptionId
    )
  }
`;
